import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FavoriteType } from '@kcftech/prometheustypescriptapiclient';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export type NoFavoritesProps = Readonly<{
    favoriteType: FavoriteType;
}>;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${tokens.background.default};
    color: ${tokens.text.secondary};
    padding: 30rem;
`;

/**
 * Pluralize a given Favorite type. Utilizes switch to insure that if there are special cases (not just adding an 's'),
 * we can account for those and return the proper plural form.
 * @param favoriteType type of Favorite to pluralize
 * @returns the favorite passed in plural
 */
const pluralFavoriteType = (favoriteType: FavoriteType): string => {
    switch (favoriteType) {
        case FavoriteType.PowerBiDashboard:
            return 'Dashboards';
        case FavoriteType.Corporation:
        case FavoriteType.Location:
        case FavoriteType.System:
        default:
            return `${favoriteType}s`;
    }
};

const Break = styled.div`
    flex-basis: 100%;
`;

export function NoFavorites({ favoriteType }: NoFavoritesProps) {
    return (
        <MessageContainer className="mt-50">
            <span>
                You currently do not have any Favorites. You can add Favorites by
                selecting the
                <FontAwesomeIcon
                    className="px-5"
                    color={tokens.misc.favorite}
                    icon={faStar}
                />
                {`from "All ${pluralFavoriteType(favoriteType)}"`} tiles.
            </span>
            <Break />
            <span className="pt-5">
                {`After selecting your Favorites, those ${pluralFavoriteType(
                    favoriteType
                )} will display here for quick access.`}
            </span>
        </MessageContainer>
    );
}
